export default __webpack_public_path__ + "static/media/Dj Tik Tok terbaru 2020 - Dj Saranghae Tik Tok Remix Terbaru 2020 Full Bass Viral Enak.9555dbae.mp3";